import {
  asidebarIcon,
  constantsHubIcon,
  redirections,
} from "../../utils/constants";
import AddMetamask from "./AddMetamask";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router-dom";

const variants = {
  open: {
    opacity: 1,
    x: 0,
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
  closed: {
    opacity: 0,
    x: "-100%",
    transition: {
      type: "spring",
      stiffness: 400,
      damping: 40,
    },
  },
};

function Asidebar({ isMenuOpen, setIsMenuOpen }) {
  const isMobile = useMediaQuery({ query: "(max-width: 1250px)" });

  return (
    // <motion.aside
    //   className={`fixed top-0 !left-0 laptop:top-4 laptop:!left-4 w-full bg-smokeyBlack laptop:flex md:max-w-[308px] border-[1.5px] border-white/10 laptop:rounded-3xl flex-col laptop:bg-white/[0.04] bg-noise bg-cover bg-no-repeat bg-left-top z-10 laptop:z-0 p-2 pb-[30px] max-h-dvh min-h-dvh laptop:min-h-[calc(100%-32px)] laptop:max-h-[calc(100%-32px)]`}
    //   animate={isMenuOpen ? "open" : "closed"}
    //   variants={isMobile && variants}
    // >
    //   <div className="relative mt-5 laptop:mt-0">
    //     <button
    //       className="absolute mr-[10px] top-0 right-0 block laptop:hidden"
    //       onClick={() => setIsMenuOpen(!isMenuOpen)}
    //     >
    //       {constantsHubIcon.closeIcon}
    //     </button>
    //     <div className="rounded-2xl bg-white/[0.06] h-30 items-center justify-center hidden laptop:flex py-5">
    //       <img
    //         src={`${process.env.REACT_APP_S3_ASSETS_URL}vanar-hub.svg`}
    //         alt="Vanar Hub"
    //         className="max-w-[220px] max-h-full"
    //       />
    //     </div>
    //     <div className="flex items-center ml-[10px] w-180 h-auto *:w-full *:h-full block laptop:hidden">
    //       {/* {constantsHubIcon.vanarIcon} */}
    //       <img
    //         src={`${process.env.REACT_APP_S3_ASSETS_URL}vanar-hub.svg`}
    //         alt="Vanar Hub"
    //         className="max-w-[220px] max-h-full"
    //       />
    //     </div>
    //     <ul className="px-3 my-8">
    //       <li className="relative py-2">
    //         <NavLink
    //           to="/"
    //           id="gettingStarted"
    //           onClick={() => setIsMenuOpen(!isMenuOpen)}
    //           className={({ isActive }) =>
    //             `asidebar-link relative flex items-center gap-2 ${isActive ? "text-green active" : "text-white"
    //             } duration-100 text-[18px]/[24px] tracking-[-4%] font-medium hover:text-green px-4 w-fit`
    //           }
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.getStarted}
    //           </span>
    //           Getting Started
    //         </NavLink>
    //       </li>

    //       <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

    //       <li className="relative py-2">
    //         <a
    //           id="staking"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px]   tracking-[-4%] font-medium px-4 w-fit"
    //           href={redirections.DPOS}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.DPoS}
    //           </span>
    //           Staking
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <NavLink
    //           id="bridge"
    //           to="/bridge"
    //           onClick={() => setIsMenuOpen(!isMenuOpen)}
    //           className={({ isActive }) =>
    //             `asidebar-link relative flex items-center gap-2 ${isActive ? "text-green active" : "text-white"
    //             } duration-100 text-[18px]/[24px] tracking-[-4%] font-medium hover:text-green px-4 w-fit`
    //           }
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.bridge}
    //           </span>
    //           Bridge
    //         </NavLink>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="rewardsPortal"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.CLAIM_PRE_STAKE}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.rewardPortal}
    //           </span>
    //           Rewards Portal
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="swap"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.SWAP}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.swap}
    //           </span>
    //           Swap
    //         </a>
    //       </li>
    //       {/* <li className="relative py-2">
    //         <a
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
    //           href={redirections.FARM}
    //           target="_blank"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.farm}
    //           </span>
    //           Farm $VANRY
    //         </a>
    //       </li> */}
    //       <li className="relative py-2">
    //         <a
    //           className="asidebar-link relative flex items-center gap-2 text-white/25 duration-100 text-[18px]/[24px] tracking-[-4%] font-medium cursor-not-allowed px-4 w-fit"
    //           // href={redirections.BRIDGE}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.farm}
    //           </span>
    //           Launchpool
    //           <div className="inline-flex justify-center items-center text-[12px] font-semibold rounded-full px-2 bg-dim/50 text-black h-5">
    //             Coming Soon
    //           </div>
    //         </a>
    //       </li>

    //       <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

    //       {/* <li className="relative py-2">
    //         <a className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
    //           href={redirections.BUY_NFT}
    //           target="_blank"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.buyNFT}
    //           </span>
    //           Buy NFTs
    //         </a>
    //       </li> */}
    //       <li className="relative py-2">
    //         <a
    //           id="buyVanry"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.BUY_VANRY}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.buyVanry}
    //           </span>
    //           Buy $VANRY
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="ecosystem"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.ECOSYSTEM}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.ecosystem}
    //           </span>
    //           Ecosystem
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="blockchainExplorer"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.BLOCKCHAIN_EXPLORER}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.blockchain}
    //           </span>
    //           Blockchain Explorer
    //         </a>
    //       </li>

    //       <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

    //       <li className="relative py-2">
    //         <a
    //           id="developers"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.TUTORIALS}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.developers}
    //           </span>
    //           Developers
    //         </a>
    //       </li>

    //       <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />
    //       {/* <li className="relative py-2">
    //         <a
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
    //           href={redirections.DOCS_VANAR}
    //           target="_blank"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.docs}
    //           </span>
    //           Docs
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
    //           href={redirections.ABOUT_VANAR}
    //           target="_blank"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.about}
    //           </span>
    //           About Vanar
    //         </a>
    //       </li> */}
    //       <li className="relative py-2">
    //         <a
    //           id="tutorials"
    //           className="asidebar-link relative flex items-center gap-2  duration-100 text-sm leading-6 tracking-004 font-medium  px-4 w-fit"
    //           href={redirections.ACADEMY}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.tutorials}
    //           </span>
    //           Academy

    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="testnet"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.TESTNET}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.buyVanry}
    //           </span>
    //           Testnet
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="faucet"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.FAUCET}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.faucet}
    //           </span>
    //           Faucet
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="rpc"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.RPC}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.rpc}
    //           </span>
    //           RPC
    //         </a>
    //       </li>
    //       <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />
    //       <li className="relative py-2">
    //         <a
    //           id="support"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4 w-fit"
    //           href={redirections.CONNECT_SUPPORT}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.connectSupport}
    //           </span>
    //           Support
    //         </a>
    //       </li>
    //       <li className="relative py-2">
    //         <a
    //           id="shareFeedback"
    //           className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
    //           href={redirections.SHARE_FEEDBACK}
    //           target="_blank"
    //           rel="noreferrer"
    //         >
    //           <span className="size-[22px] lg:size-6 *:size-full">
    //             {asidebarIcon.shareFeedback}
    //           </span>
    //           Share feedback
    //         </a>
    //       </li>
    //     </ul>
    //     <AddMetamask />
    //   </div>
    // </motion.aside>
    <motion.aside
      className="fixed top-0 left-0 w-full laptop:flex md:max-w-[332px] flex-col z-10 laptop:z-0 p-2 pb-[30px] max-h-dvh min-h-dvh laptop:min-h-[calc(100%-32px)] laptop:max-h-[calc(100%-32px)] bg-hoverCardBG bg-no-repeat bg-bottom overflow-hidden !bg-black"
      animate={isMenuOpen ? "open" : "closed"}
      variants={isMobile && variants}
    >
      <div className="relative mt-5 laptop:mt-0 ">
        <button
          className="absolute mr-[10px] top-0 right-0 block laptop:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {constantsHubIcon.closeIcon}
        </button>
        <div className=" h-30 items-center justify-center hidden laptop:flex py-5 ">
          <NavLink to="/">
            <img
              src={`${process.env.REACT_APP_S3_ASSETS_URL}vanar-hub.svg`}
              alt="Vanar Hub"
              className="max-w-[220px] max-h-full"
            />
          </NavLink>
          
        </div>
        <div className="flex items-center ml-[10px] w-180 h-auto *:w-full *:h-full block laptop:hidden">
          {/* {constantsHubIcon.vanarIcon} */}
          <img
            src={`${process.env.REACT_APP_S3_ASSETS_URL}vanar-hub.svg`}
            alt="Vanar Hub"
            className="max-w-[220px] max-h-full"
          />
        </div>
        <ul className="px-3 my-8">
          <li className="relative py-2">
            <NavLink
              to="/"
              id="gettingStarted"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={({ isActive }) =>
                `asidebar-link relative flex items-center gap-2 ${
                  isActive ? "text-green active" : "text-white"
                } duration-100 text-[18px]/[24px]   tracking-[-4%] font-medium hover:text-green px-4 w-fit`
              }
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.getStarted}
              </span>
              Getting Started
            </NavLink>
          </li>

          <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

          <li className="relative py-2">
            <a
              id="staking"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.DPOS}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.DPoS}
              </span>
              Staking
            </a>
          </li>
          <li className="relative py-2">
            <NavLink
              id="bridge"
              to="/bridge"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={({ isActive }) =>
                `asidebar-link relative flex items-center gap-2 ${
                  isActive ? "text-green active" : "text-white"
                } duration-100 text-[18px]/[24px] tracking-[-4%] font-medium hover:text-green px-4 w-fit`
              }
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.bridge}
              </span>
              Bridge
            </NavLink>
          </li>
          <li className="relative py-2">
            <a
              id="rewardsPortal"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.CLAIM_PRE_STAKE}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.rewardPortal}
              </span>
              Rewards Portal
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="swap"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.SWAP}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.swap}
              </span>
              Swap
            </a>
          </li>
          {/* <li className="relative py-2">
          <a
            className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
            href={redirections.FARM}
            target="_blank"
          >
            <span className="size-[22px] lg:size-6 *:size-full">
              {asidebarIcon.farm}
            </span>
            Farm $VANRY
          </a>
        </li> */}
          <li className="relative py-2">
            <a
              className="asidebar-link relative flex items-center gap-2 text-white/25 duration-100 text-[18px]/[24px] tracking-[-4%] font-medium cursor-not-allowed px-4 w-fit"
              // href={redirections.BRIDGE}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.farm}
              </span>
              Launchpool
              <div className="inline-flex justify-center items-center text-[12px] font-semibold rounded-full px-2 bg-dim/50 text-black h-5">
                Coming Soon
              </div>
            </a>
          </li>

          <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

          {/* <li className="relative py-2">
          <a className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
            href={redirections.BUY_NFT}
            target="_blank"
          >
            <span className="size-[22px] lg:size-6 *:size-full">
              {asidebarIcon.buyNFT}
            </span>
            Buy NFTs
          </a>
        </li> */}
          <li className="relative py-2">
            <a
              id="buyVanry"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.BUY_VANRY}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.buyVanry}
              </span>
              Buy $VANRY
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="ecosystem"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.ECOSYSTEM}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.ecosystem}
              </span>
              Ecosystem
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="blockchainExplorer"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.BLOCKCHAIN_EXPLORER}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.blockchain}
              </span>
              Blockchain Explorer
            </a>
          </li>

          <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />

          <li className="relative py-2">
            <a
              id="developers"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 tetext-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.TUTORIALS}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.developers}
              </span>
              Developers
            </a>
          </li>

          <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />
          {/* <li className="relative py-2">
          <a
            className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
            href={redirections.DOCS_VANAR}
            target="_blank"
          >
            <span className="size-[22px] lg:size-6 *:size-full">
              {asidebarIcon.docs}
            </span>
            Docs
          </a>
        </li>
        <li className="relative py-2">
          <a
            className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-sm leading-6 tracking-004 font-medium px-4"
            href={redirections.ABOUT_VANAR}
            target="_blank"
          >
            <span className="size-[22px] lg:size-6 *:size-full">
              {asidebarIcon.about}
            </span>
            About Vanar
          </a>
        </li> */}
          <li className="relative py-2">
            <a
              id="tutorials"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.ACADEMY}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.tutorials}
              </span>
              Academy
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="testnet"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.TESTNET}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.buyVanry}
              </span>
              Testnet
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="faucet"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.FAUCET}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.faucet}
              </span>
              Faucet
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="rpc"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.RPC}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.rpc}
              </span>
              RPC
            </a>
          </li>
          <hr className="max-w-[88%] mx-auto border-[1.5px] border-white/10 my-3" />
          <li className="relative py-2">
            <a
              id="support"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.CONNECT_SUPPORT}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.connectSupport}
              </span>
              Support
            </a>
          </li>
          <li className="relative py-2">
            <a
              id="shareFeedback"
              className="asidebar-link relative flex items-center gap-2 text-white hover:text-green duration-100 text-[18px]/[24px] tracking-[-4%] font-medium px-4 w-fit"
              href={redirections.SHARE_FEEDBACK}
              target="_blank"
              rel="noreferrer"
            >
              <span className="size-[22px] lg:size-6 *:size-full">
                {asidebarIcon.shareFeedback}
              </span>
              Share feedback
            </a>
          </li>
        </ul>
        <AddMetamask />
      </div>
    </motion.aside>
  );
}

export default Asidebar;
